import React from 'react'

export default function Contact() {
  const onSubmit = (e) => { e.preventDefault(); alert('Contact form submit (implement)') }
  return (
    <div className="container">
      <section className="card" style={{maxWidth:720, margin:'0 auto'}}>
        <h2 className="h2">Contact us</h2>
        <p className="kv">Questions about billing, onboarding, or partnerships? Send us a message and we'll respond within 1 business day.</p>

        <form onSubmit={onSubmit} style={{display:'grid', gap:12, marginTop:12}}>
          <input placeholder="Your name" required style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input placeholder="Email" required style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input placeholder="Subject" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <textarea rows={6} placeholder="Message" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <button className="btn primary" type="submit">Send message</button>
        </form>
      </section>
    </div>
  )
}
